import * as Ably from "ably";
import {Types, Realtime} from "ably";
import bellUrl from "./bell.mp3"


interface LocalMessage {
    type: "local",
    key: string;
}

interface ResetMessage {
    type: "reset",
}

interface RemoteMessage {
    type: "remote";
}

export type Message = RemoteMessage | LocalMessage | ResetMessage;

let audio;

export const registerAudio = () => {
    audio = new Audio(bellUrl);
}

export const playBell = () => {
    audio.play();
}

export const registerClient = async (messageCallback: (message: Message) => void) => {
    const optionalClientId = "optionalClientId"; // When not provided in authUrl, a default will be used.
    const ably = new Ably.Realtime({ authUrl: `/api/ably-token-request?clientId=${optionalClientId}` });
    const channel = ably.channels.get("some-channel-name");

    await channel.subscribe((msg: Types.Message) => {
        console.log("Ably message received", msg);
        const {type, key} = msg.data;
        messageCallback({key, type})
    });

    return channel;
}

let locked = false;
export const handleMessage = (msg: Message)  => {
    const params = new URLSearchParams(window.location.search);

    const localKeys = {
        "ArrowUp": params.get('up') ?? '⬆️',
        "ArrowRight": params.get('right') ?? '➡️',
        "ArrowLeft": params.get('left') ?? '⬅️',
        "ArrowDown": params.get('down') ?? '⬇️',
        "w": params.get('w') ?? 'W',
        "a": params.get('a') ?? 'A',
        "s": params.get('s') ?? 'S',
        "d": params.get('d') ?? 'D',
    };

    if (msg.type === "reset") {
        document.getElementById("buzzed").innerText = "";
        document.body.style.backgroundColor = "white";
        locked = false;
        return;
    }
    if (locked){
        return;
    }
    locked = true;

    if (msg.type === "remote") {
        playBell();
        document.body.style.backgroundColor = "lightblue";
        document.getElementById("buzzed").innerText = "📱";
    }
    else if (Object.keys(localKeys) .includes(msg.key)){
        playBell();
        document.body.style.backgroundColor = "lightblue";
        document.getElementById("buzzed").innerText = localKeys[msg.key]
    }

}
